import { createSlice } from "@reduxjs/toolkit"

// Standalone template payload for contexts that render product fields
// without a full product view — the Component Library, principally.
// Mirrors the shape of the +template+ block on the tour product view
// (+active_key+, +renders+, +renders_unless_present+) so the same
// selectors (+templateRenders+, +templateRendersUnlessPresent+) can
// resolve against either source.
export const Slice = createSlice({
  name: "template",
  initialState: {
    payload: null,
  },
  reducers: {
    setTemplate: (state, { payload }) => {
      state.payload = payload
      return state
    },
  },
})

export const { setTemplate } = Slice.actions

export default Slice
